angular.module('ui2.0Controllers').controller('documentVisibilityController', ['$scope', '$uibModal', 'entityFactory', '$rootScope','$location', '$templateCache', '$compile', '$timeout', '$http', '$window', '$anchorScroll', 'urlFactory', '$routeParams', '$sce', '$document', '$route', '$filter', '$q', 'showPageService', function ($scope, $modal, entityFactory, $rootScope, $location, $templateCache, $compile, $timeout, $http, $window, $anchorScroll, urlFactory, $routeParams, $sce, $document, $route, $filter, $q, $showPageService) {
    $scope.selectedDocuments = [];
    $scope.selectedStakeholders = [];
    $scope.dataOFUnckeckedUser = {};
    $scope.allUnckecked = true;
    $scope.docuVisibilityForAtLeastOneRecipient = true;
    $scope.atLeastOneDocuVisibleForRecipient = true;
    $scope.currentSendSignatureData = $('.send-signature').scope();
    $scope.selectedDocuments = $scope.currentSendSignatureData.selectedDocForSign;
    $scope.selectedStakeholders = $scope.currentSendSignatureData.selectedUserForSign;
    $scope.signerTypeDataForNote = $scope.currentSendSignatureData.signerType;
    $scope.allDocDefaultVisibilityFlagPermission = $scope.currentSendSignatureData.allDocumentVisibilityFlagPermission;
    $scope.newDocumentForSignature = $scope.currentSendSignatureData.newDocumentForSignature;
    $scope.nonVisibleDocuments = JSON.parse(JSON.stringify($scope.currentSendSignatureData.nonVisibilityValuesOfStakeholders));
    $scope.copyOfNonVisibilityData = JSON.parse(JSON.stringify($scope.currentSendSignatureData.nonVisibilityValuesOfStakeholders));
    $scope.getUnckeckedData = ()=>{
        $scope.selectedStakeholders.map((stake)=>{
            $scope.nonVisibleDocuments[stake.id] = $scope.nonVisibleDocuments[stake.id] ? $scope.nonVisibleDocuments[stake.id] : stake.nonVisibleDocumentIds ? stake.nonVisibleDocumentIds : []  ;
            if($scope.nonVisibleDocuments[stake.id] && $scope.nonVisibleDocuments[stake.id].length > 0){
                $scope.nonVisibleDocuments[stake.id].map((item)=>{
                    $scope.dataOFUnckeckedUser[item] = [];
                    $scope.dataOFUnckeckedUser[item].push(stake.id);
                } )
            }
        });
    }
    $scope.addNewDocInNonVisibleData = () => {
        if($scope.newDocumentForSignature.length && $scope.allDocDefaultVisibilityFlagPermission === "false"){
            $scope.newDocumentForSignature.map((item)=>{
                $scope.selectedStakeholders.map((stake)=>{
                    if(!$scope.nonVisibleDocuments[stake.id])$scope.nonVisibleDocuments[stake.id]=[];
                    $scope.nonVisibleDocuments[stake.id].push(item);
                })
            });
        }
    }
    if($scope.currentSendSignatureData.reqId) {
        $scope.addNewDocInNonVisibleData();
        $scope.getUnckeckedData();
    }else{
        if(Object.keys($scope.nonVisibleDocuments).length === 0 && $scope.nonVisibleDocuments.constructor === Object) {
            $scope.selectedStakeholders.map((elm) => {
                $scope.nonVisibleDocuments[elm.id] = [];
            })
        }else{
            $scope.addNewDocInNonVisibleData();
            $scope.getUnckeckedData();
        }
    }
    if($scope.allDocDefaultVisibilityFlagPermission === "false" && Object.keys($scope.copyOfNonVisibilityData).length === 0 && !$scope.currentSendSignatureData.reqId ){
        $scope.selectedStakeholders.map((elm) => {
            $scope.selectedDocuments.map((Doc)=>{
                $scope.nonVisibleDocuments[elm.id].push(Number(Doc.documentId));
            })
        });
        $rootScope.$emit("update visibility data", $scope.nonVisibleDocuments);
    }
    $scope.handleCheckBoxValue = function (docID,user,stakeholdersForDoc) {
        if($scope.currentSendSignatureData.reqId && user.nonVisibleDocumentIds){
            if($scope.nonVisibleDocuments[user.id] && $scope.nonVisibleDocuments[user.id].includes(Number(docID))){
                return false;
            }else{
                if(stakeholdersForDoc && stakeholdersForDoc.length && user.role === "Signer"){
                    let signerRoleCheckbox = false;
                    stakeholdersForDoc.map((stack)=>{
                        if(stack.id === user.id){
                            signerRoleCheckbox = true;
                            if($scope.nonVisibleDocuments[user.id] && $scope.nonVisibleDocuments[user.id].includes(Number(docID))){
                                let index = $scope.nonVisibleDocuments[user.id].indexOf(Number(docID));
                                if (index > -1) {
                                    $scope.nonVisibleDocuments[user.id].splice(index, 1);
                                }
                            }
                            if($scope.dataOFUnckeckedUser[Number(docID)] && $scope.dataOFUnckeckedUser[Number(docID)].includes(user.id)){
                                let index = $scope.dataOFUnckeckedUser[Number(docID)].indexOf(user.id);
                                if (index > -1) {
                                    $scope.dataOFUnckeckedUser[Number(docID)].splice(index, 1);
                                }
                            }
                        }else if($scope.signerTypeDataForNote && !$scope.nonVisibleDocuments[user.id].includes(Number(docID))){
                                signerRoleCheckbox = true;
                        }
                    })
                    if(!signerRoleCheckbox){
                        $scope.handleDataForUncheckedUser(docID,user);
                    }
                    return signerRoleCheckbox;
                }else  if(Object.keys($scope.currentSendSignatureData.nonVisibilityValuesOfStakeholders).length > 0) {
                    if($scope.nonVisibleDocuments[user.id] && $scope.nonVisibleDocuments[user.id].includes(Number(docID))) {
                        return false;
                    } else {
                        return true;
                    }
                }
                else{
                    return true;
                }
            }
        } else{

            if(stakeholdersForDoc && stakeholdersForDoc.length && user.role === "Signer"){
                let signerRoleCheckbox = false;
                for(let i=0;i<stakeholdersForDoc.length;i++){
                    if(stakeholdersForDoc[i].id === user.id){
                        signerRoleCheckbox = true;
                        if($scope.nonVisibleDocuments[user.id] && $scope.nonVisibleDocuments[user.id].includes(Number(docID))){
                            let index = $scope.nonVisibleDocuments[user.id].indexOf(Number(docID));
                            if (index > -1) {
                                $scope.nonVisibleDocuments[user.id].splice(index, 1);
                            }
                        }
                        if($scope.dataOFUnckeckedUser[Number(docID)] && $scope.dataOFUnckeckedUser[Number(docID)].includes(user.id)){
                            let index = $scope.dataOFUnckeckedUser[Number(docID)].indexOf(user.id);
                            if (index > -1) {
                                $scope.dataOFUnckeckedUser[Number(docID)].splice(index, 1);
                            }
                        }
                        break;
                    }else if($scope.signerTypeDataForNote && !$scope.nonVisibleDocuments[user.id].includes(Number(docID))){
                        if($scope.allDocDefaultVisibilityFlagPermission === "false" && (!(Object.keys($scope.copyOfNonVisibilityData).length >0) || !$scope.copyOfNonVisibilityData[user.id])){
                            !$scope.nonVisibleDocuments[user.id].includes(Number(docID)) && $scope.nonVisibleDocuments[user.id].push(Number(docID));
                            signerRoleCheckbox = !($scope.allDocDefaultVisibilityFlagPermission === "false");
                        }else{
                            signerRoleCheckbox = true;
                        }
                    }
                }
                if(!signerRoleCheckbox){
                    $scope.handleDataForUncheckedUser(docID,user);
                }
                return signerRoleCheckbox;
            }else  if(Object.keys($scope.copyOfNonVisibilityData).length > 0 && $scope.copyOfNonVisibilityData[user.id]){
                if($scope.nonVisibleDocuments[user.id] && $scope.nonVisibleDocuments[user.id].includes(Number(docID))){
                    return false;
                }else{
                    return true;
                }
            }
            else{
                if($scope.allDocDefaultVisibilityFlagPermission === "false"){
                    !$scope.nonVisibleDocuments[user.id].includes(Number(docID)) && $scope.nonVisibleDocuments[user.id].push(Number(docID));
                    $scope.handleDataForUncheckedUser(docID,user);
                }
                return !($scope.allDocDefaultVisibilityFlagPermission === "false");
            }

        }

    }

    $scope.handleClickOnCheckbox = function (event,docID,user) {
        if(!user.email && !user.name && !user.id && !user.userId){
            event.currentTarget.children[0].checked = false;
            Toaster.create(intl_msg[32384]);
            return;
        }
        if( event.currentTarget.children && !event.currentTarget.children[0].disabled) {
            if (event.currentTarget.children[0].checked) {
                let index = $scope.dataOFUnckeckedUser[Number(docID)].indexOf(user.id);
                if (index > -1) {
                    $scope.dataOFUnckeckedUser[Number(docID)].splice(index, 1);
                }
            } else {
                if ($scope.dataOFUnckeckedUser[Number(docID)] === undefined) {
                    $scope.dataOFUnckeckedUser[Number(docID)] = [];
                    $scope.dataOFUnckeckedUser[Number(docID)].push(user.id);
                } else {
                    !$scope.dataOFUnckeckedUser[Number(docID)].includes(user.id) && $scope.dataOFUnckeckedUser[Number(docID)].push(user.id);
                }

            }
            if ($scope.dataOFUnckeckedUser[Number(docID)].length === $scope.selectedStakeholders.length) {
                Toaster.create( intl_msg[33397] || "A document to be visible to at least one recipient or else please remove the document", {iconClass: "icon-Information_filled"});
                event.currentTarget.children[0].checked = true;
                let index = $scope.dataOFUnckeckedUser[Number(docID)].indexOf(user.id);
                if (index > -1) {
                    $scope.dataOFUnckeckedUser[Number(docID)].splice(index, 1);
                }
            }
            let stackholderIsUncheckedFromAllFile = [];
            $scope.selectedDocuments.forEach((doc)=>{
                if($scope.dataOFUnckeckedUser[Number(doc.documentId)] && $scope.dataOFUnckeckedUser[Number(doc.documentId)].includes(user.id)){
                    stackholderIsUncheckedFromAllFile.push(Number(doc.documentId));
                }
            })
            if(stackholderIsUncheckedFromAllFile.length === $scope.selectedDocuments.length){
                Toaster.create(intl_msg[34961] || "A recipient should have visibility to at least one document or else please remove the recipient", {iconClass: "icon-Information_filled"});
                event.currentTarget.children[0].checked = true;
                let index = $scope.dataOFUnckeckedUser[Number(docID)].indexOf(user.id);
                if (index > -1) {
                    $scope.dataOFUnckeckedUser[Number(docID)].splice(index, 1);
                }
            }
            if (event.currentTarget.children[0].checked) {
                if ($scope.nonVisibleDocuments[user.id] !== undefined) {
                    $scope.nonVisibleDocuments[user.id] = $scope.nonVisibleDocuments[user.id].filter(item => item !== Number(docID))
                }
                $scope.copyOfNonVisibilityData = JSON.parse(JSON.stringify($scope.nonVisibleDocuments));
            } else {
                if ($scope.nonVisibleDocuments[user.id] === undefined) {
                    $scope.nonVisibleDocuments[user.id] = [];
                    $scope.nonVisibleDocuments[user.id].push(Number(docID));
                } else {
                    $scope.nonVisibleDocuments[user.id].push(Number(docID));
                }
                $scope.copyOfNonVisibilityData = JSON.parse(JSON.stringify($scope.nonVisibleDocuments));
            }
        }
    }

    $scope.handleDataForUncheckedUser = (docID,user)=> {
        if(!$scope.dataOFUnckeckedUser[Number(docID)]) {
            $scope.dataOFUnckeckedUser[Number(docID)] = [];
            $scope.dataOFUnckeckedUser[Number(docID)].push(user.id);
        }else {
            !$scope.dataOFUnckeckedUser[Number(docID)].includes(user.id) && $scope.dataOFUnckeckedUser[Number(docID)].push(user.id);
        }
    };

    $scope.handleUserDisabledToClick =function(currentUser,stakeholdersForDoc){
        let returnVal = false;
        if(currentUser.signingStatus && currentUser.signingStatus.toLowerCase().includes("completed")){
            return true;
        }
        stakeholdersForDoc && stakeholdersForDoc.map((userStake)=>{
            if(userStake.id === currentUser.id) {
                returnVal = true;
            }
        });
        return returnVal
    }

    $scope.closeThePopupAndCancel = function (){
        $scope.handleValidation();
        $scope.currentSendSignatureData.createPopUpforVisibleDocument.close();
    }

    $scope.handleDoneToAddNonVisibleData = function () {
        $scope.handleValidation();
        if($scope.atLeastOneDocuVisibleForRecipient && $scope.docuVisibilityForAtLeastOneRecipient) {
            $rootScope.$emit("update visibility data", $scope.nonVisibleDocuments);
            $scope.currentSendSignatureData.createPopUpforVisibleDocument.close();
        }
    }

    $scope.handleValidation = ()=>{
        $scope.docuVisibilityForAtLeastOneRecipient = true;
        $scope.atLeastOneDocuVisibleForRecipient = true;
        for(let i=0;i<$scope.selectedStakeholders.length;i++){
            if($scope.nonVisibleDocuments[$scope.selectedStakeholders[i].id].length === $scope.selectedDocuments.length){
                Toaster.create(intl_msg[34961] || "A recipient should have visibility to at least one document or else please remove the recipient", {iconClass: "icon-Information_filled"});
                $scope.atLeastOneDocuVisibleForRecipient = false;
                break;
            }
        }
        for(let i=0;i<$scope.selectedDocuments.length;i++){
            let count = 0;
            $scope.selectedStakeholders.map((stack)=>{
                if($scope.nonVisibleDocuments[stack.id].includes(Number($scope.selectedDocuments[i].documentId))){
                    count++;
                }
            })
            if(count === $scope.selectedStakeholders.length){
                Toaster.create( intl_msg[33397] || "A document to be visible to at least one recipient or else please remove the document", {iconClass: "icon-Information_filled"});
                $scope.docuVisibilityForAtLeastOneRecipient = false;
                break;
            }
        }
        $rootScope.$emit("update validation",$scope.docuVisibilityForAtLeastOneRecipient,$scope.atLeastOneDocuVisibleForRecipient);
    }

}]);